/**
 * Script de consola para probar la nueva estructura optimizada
 */

// Exportar para que TypeScript considere esto un módulo
export {};

// Función para probar la nueva estructura
(window as any).testOptimizedStructure = async function() {
  console.log('🧪 Probando nueva estructura optimizada...');
  
  try {
    // Importar el servicio optimizado
    const { default: optimizedService } = await import('../services/optimizedInventoryService');
    
    console.log('✅ Servicio optimizado cargado');
    
    // Crear una categoría de prueba
    console.log('📂 Creando categoría de prueba...');
    const categoryName = await optimizedService.createCategory({
      name: 'Campera',
      fields: {
        material: { type: 'text', required: true },
        temporada: { type: 'select', options: ['Verano', 'Invierno', 'Todo el año'], required: true }
      }
    });
    console.log(`✅ Categoría creada: ${categoryName}`);
    
    // Crear una marca de prueba
    console.log('🏷️ Creando marca de prueba...');
    const brandSlug = await optimizedService.createBrand({
      name: 'Nike',
      description: 'Marca deportiva',
      website: 'https://nike.com'
    });
    console.log(`✅ Marca creada con slug: ${brandSlug}`);
    
    // Crear un proveedor de prueba
    console.log('🚚 Creando proveedor de prueba...');
    const supplierSlug = await optimizedService.createSupplier({
      name: 'Proveedor Test',
      contact: 'Juan Pérez',
      email: 'juan@test.com',
      phone: '+54 11 1234-5678'
    });
    console.log(`✅ Proveedor creado con slug: ${supplierSlug}`);
    
    console.log('🎉 Prueba de estructura completada exitosamente');
    console.log('📋 Estructura creada:');
    console.log(`  - Categoría: users/{userId}/categorys/${categoryName}`);
    console.log(`  - Marca: users/{userId}/brands/${brandSlug}`);
    console.log(`  - Proveedor: users/{userId}/suppliers/${supplierSlug}`);
    
    return {
      categoryName,
      brandSlug,
      supplierSlug
    };
    
  } catch (error) {
    console.error('❌ Error en prueba de estructura:', error);
    throw error;
  }
};

// Función para verificar la estructura actual
(window as any).checkOptimizedStructure = async function() {
  console.log('🔍 Verificando estructura optimizada...');
  
  try {
    const { default: optimizedService } = await import('../services/optimizedInventoryService');
    
    // Verificar categorías
    const categories = await optimizedService.getCategories();
    console.log(`📂 Categorías encontradas: ${categories.length}`);
    categories.forEach(cat => {
      console.log(`  - ${cat.name} (${cat.id})`);
    });
    
    // Verificar marcas
    const brands = await optimizedService.getBrands();
    console.log(`🏷️ Marcas encontradas: ${brands.length}`);
    brands.forEach(brand => {
      console.log(`  - ${brand.name} (${brand.id})`);
    });
    
    // Verificar proveedores
    const suppliers = await optimizedService.getSuppliers();
    console.log(`🚚 Proveedores encontrados: ${suppliers.length}`);
    suppliers.forEach(supplier => {
      console.log(`  - ${supplier.name} (${supplier.id})`);
    });
    
    // Verificar productos
    const products = await optimizedService.getProducts();
    console.log(`📦 Productos encontrados: ${products.length}`);
    products.forEach(product => {
      console.log(`  - ${product.name} (${product.sku}) en categoría ${product.category}`);
    });
    
    return {
      categories: categories.length,
      brands: brands.length,
      suppliers: suppliers.length,
      products: products.length
    };
    
  } catch (error) {
    console.error('❌ Error verificando estructura:', error);
    throw error;
  }
};

// Función para limpiar datos de prueba
(window as any).cleanupTestData = async function() {
  console.log('🧹 Limpiando datos de prueba...');
  
  try {
    const { default: databaseCleanup } = await import('../utils/databaseCleanup');
    
    const summary = await databaseCleanup.cleanAll();
    
    console.log('✅ Limpieza completada:', summary);
    return summary;
    
  } catch (error) {
    console.error('❌ Error limpiando datos de prueba:', error);
    throw error;
  }
};

console.log('🧪 Scripts de prueba de estructura optimizada cargados:');
console.log('- window.testOptimizedStructure() - Probar nueva estructura');
console.log('- window.checkOptimizedStructure() - Verificar estructura actual');
console.log('- window.cleanupTestData() - Limpiar datos de prueba');
